// Words inside the shared calculator form card on the 33 Hindi antardasha
// pages (hi/mahadasha/<maha>/<antar>-antardasha): submit, the check's errors
// and the two controls of its answer. Hindi is Devanagari (owner decision
// 2026-10-28, which replaced the 2026-10-08 Hinglish rule), the register of the
// card's labels in BirthDetailsForm.i18n.ts; tests/hindi-register.test.ts keeps
// Latin-letter Hinglish out of it. The section heading and the answer's text
// are page copy and are Devanagari in their components.
export const RUNNING_ANTARDASHA_CARD_COPY = {
  submit: "अपनी अंतर्दशा देखें",
  // The shared hint names the Lagna; dasha dates follow the Moon. As long as
  // the shared one, so the form keeps its measured height.
  timeRequiredHint: "दशा चंद्र की स्थिति से बनती है — सही समय ज़रूरी है।",
  unavailable: "अंतर्दशा की गणना अभी उपलब्ध नहीं है। कृपया दोबारा कोशिश करें।",
  needsTime: "इस जाँच के लिए जन्म समय ज़रूरी है। समय डालकर दोबारा देखें।",
  futureBirth: "जन्म तिथि भविष्य की नहीं हो सकती।",
  checkAnother: "दूसरी जन्म तिथि जाँचें",
  fullTimeline: "पूरी दशा समयरेखा देखें",
} as const;
